
import { NetworkDevice, Link, PingResult } from '../types';

export const isValidIP = (ip: string): boolean => {
  const pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  return pattern.test(ip);
};

export const ipInSubnet = (ip: string, subnet: string, targetIp: string): boolean => {
  if (!isValidIP(ip) || !isValidIP(targetIp)) return false;
  const ipParts = ip.split('.');
  const targetParts = targetIp.split('.');
  return ipParts[0] === targetParts[0] && 
         ipParts[1] === targetParts[1] && 
         ipParts[2] === targetParts[2];
};

export const findPath = (
  startId: string, 
  endId: string, 
  devices: NetworkDevice[], 
  links: Link[]
): string[] | null => {
  const queue: string[][] = [[startId]];
  const visited = new Set([startId]);

  while (queue.length > 0) {
    const path = queue.shift()!;
    const lastNode = path[path.length - 1];

    if (lastNode === endId) return path;

    const neighbors = links
      .filter(l => l.from === lastNode || l.to === lastNode)
      .map(l => l.from === lastNode ? l.to : l.from);

    for (const neighbor of neighbors) {
      if (!visited.has(neighbor)) {
        visited.add(neighbor);
        queue.push([...path, neighbor]);
      }
    }
  }
  return null;
};

export const simulatePing = (
  sourceId: string,
  targetIp: string,
  devices: NetworkDevice[],
  links: Link[]
): PingResult => {
  const source = devices.find(d => d.id === sourceId);
  const target = devices.find(d => d.ip === targetIp);

  if (!source || source.type !== 'DASHBOARD') {
    return { success: false, message: "Error: Tes hanya bisa dilakukan dari Smartphone Dashboard.", path: [] };
  }

  if (!source.ip || !isValidIP(source.ip)) {
    return { success: false, message: "Smartphone belum diatur IP Lokal-nya!", path: [] };
  }

  if (!isValidIP(targetIp)) {
    return { success: false, message: "Format alamat IP salah.", path: [] };
  }

  if (!target) {
    return { success: false, message: "Signal Lost: Perangkat tujuan tidak ditemukan.", path: [] };
  }

  const path = findPath(source.id, target.id, devices, links);
  if (!path) {
    return { success: false, message: "No Wire: Tidak ada kabel jumper ke tujuan.", path: [] };
  }

  const isTargetCloud = target.type === 'CLOUD';
  const sameSubnet = ipInSubnet(source.ip, "255.255.255.0", target.ip!);

  if (sameSubnet) {
    return { 
      success: true, 
      message: `Data OK dari ${targetIp}: Koneksi Jaringan Lokal Stabil.`, 
      path 
    };
  } else {
    const pathDevices = path.map(id => devices.find(d => d.id === id));
    const hasController = pathDevices.some(d => d?.type === 'CONTROLLER');
    
    if (!hasController) {
      return { success: false, message: "Data terhenti: Butuh Mikrokontroler (ESP32) untuk menyeberangkan data.", path };
    }

    const gatewayDevice = devices.find(d => d.type === 'CONTROLLER' && d.ip === source.gateway);
    if (!source.gateway || !gatewayDevice) {
      return { success: false, message: "Gateway Error: Smartphone tidak tahu alamat IP Controller-nya.", path };
    }

    return { success: true, message: `Cloud Link OK from ${targetIp}: Dashboard terhubung via ESP32.`, path };
  }
};
